var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32502 16.5066C8.07455 17.404 10.0871 17.6471 12 17.192C13.9129 16.7369 15.6004 15.6136 16.7583 14.0244C17.9162 12.4352 18.4685 10.4847 18.3156 8.52437C18.1626 6.56403 17.3146 4.72278 15.9242 3.3324C14.5338 1.94202 12.6925 1.09395 10.7322 0.941018C8.77187 0.788086 6.82137 1.34035 5.23219 2.49828C3.64301 3.65621 2.51965 5.34367 2.06456 7.25657C1.60946 9.16948 1.85255 11.182 2.75002 12.9316L0.916687 18.3399L6.32502 16.5066Z",
    stroke: "#90A1B9",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSource);
export default __webpack_public_path__ + "static/media/source.07900682f81811160177644ea2be971c.svg";
export { ForwardRef as ReactComponent };